import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { LoginService } from "./servicios/login-service.service";
import { SignalRService } from "./servicios/signal-r.service";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { ConfiguracionService } from "./servicios/configuracion.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "ALLY";
  urlBackEnd: any;

  login = false;
  constructor(
    private loginService: LoginService,
    public router: Router,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private signalRService: SignalRService,
    private servicioConfiguracion: ConfiguracionService
  ) {
    if (sessionStorage.getItem("isLoggedIn")) {
      this.login = true;
    }
    this.matIconRegistry.addSvgIcon(
      "excel",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/excel.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "csv",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/csv.svg")
    );

    //  alert("app.component");
  }

  ngOnInit() {
    //this.cargarUrl();

    // alert(this.loginService.getUserLoggedIn());
    if (this.loginService.getUserLoggedIn() == "1") {
      //alert("verdadero");

      //this.signalRService.startConnection();
      //this.signalRService.sinalRListener();

      this.login = true;
      let ruta = sessionStorage.getItem("ruta");
      if (ruta) {
        this.router.navigate([ruta]);
      } else {
        this.router.navigate(["inicio"]);
      }

      //alert(this.login);
    } else {
      this.login = false;
      this.router.navigate(["login"]);
      //alert("this.login "+this.login);
      //alert("falso");
    }
    //alert(this.login);
  }

  async cargarUrl() {
    console.log("entro");
    const config = await this.servicioConfiguracion.getConfig().toPromise();
    this.urlBackEnd = config.url;
    console.log(this.urlBackEnd);
  }
}
